<dcp-configurator-single-page-form [hideConfiguration]="hideConfiguration">
  <dcp-configure-service-error (configureServiceError)="hideConfiguration = $event"></dcp-configure-service-error>
</dcp-configurator-single-page-form>
